export function getRolesForListCompany(rights) {
    const companyRolesParentId = "LIST_COMPANY.filters.companyRoles";
    let roles = [];

    for (const rightId in rights) {
        if (rightId.indexOf(companyRolesParentId) === 0) {
            roles.push(+rightId.replace(companyRolesParentId + ".", ""));
        }
    }
    roles = roles.filter((role) =>
        role && role > 0
    );

    return roles;
}
